module.exports = __webpack_public_path__ + "media/images/logo_ville_shawinigan-d69d7d105fd6bdce0118581cded0a0f3.png";